import { render, staticRenderFns } from "./BunkerSummaryChart.vue?vue&type=template&id=0e177d6c&scoped=true"
import script from "./BunkerSummaryChart.vue?vue&type=script&lang=js"
export * from "./BunkerSummaryChart.vue?vue&type=script&lang=js"
import style0 from "./BunkerSummaryChart.vue?vue&type=style&index=0&id=0e177d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e177d6c",
  null
  
)

export default component.exports